module.exports = __webpack_public_path__ + "res/12-img_game_text_l.fec8874cc5533258ad8d52b3603020f0.png";